import { IconsMockApi } from "app/mock-api/ui/icons/api";

export const mockApiServices = [IconsMockApi];
